export const FEATURE_FLAG_KEYS = {
  cardCollectionResponsiveColumns: "EnableCcofResponsiveCardCollectionTable",
  // Shared with the backend and admin; targeting must match on `email`.
  sessionPermissionsFromBackend: "SessionPermissionsFromBackend",
} as const;
